import axios from 'axios'
import {
  baseURL,
  contentType,
  debounce,
  requestTimeout,
  successCode,
  requestTokenName,
  ignoreRequest,
  refreshToken,
} from '@/config'
import store from '@/store'
import qs from 'qs'
import router from '@/router'
import { isArray } from '@/utils/validate'
import { message } from 'ant-design-vue'
import { logout, checkRemaining } from '@/utils/auth'

let timer
function debounceMsg(msg) {
  clearTimeout(timer)
  timer = setTimeout(() => message.warn(msg), 200)
}

let loadingInstance
/**
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
const handleCode = (code, msg) => {
  switch (code) {
    case 401: //token过期
    case 1001: //token过期
      logout()
      break
    case 403:
      router.push({ path: '/401' }).catch(() => {})
      break
    default:
      debounceMsg(msg || `后端接口${code}异常`)
      break
  }
}

/**
 * @description axios初始化
 */
const instance = axios.create({
  baseURL,
  timeout: requestTimeout,
  headers: {
    'Content-Type': contentType,
  },
})

/**
 * @description axios请求拦截器
 */
instance.interceptors.request.use(
  (config) => {
    if (!ignoreRequest.includes(config.url) && refreshToken)
      if (!checkRemaining()) return Promise.reject('登录过期，请求被取消')
    if (store.getters['user/accessToken'])
      config.headers[requestTokenName] = store.getters['user/accessToken']
    if (
      config.data &&
      config.headers['Content-Type'] ===
        'application/x-www-form-urlencoded;charset=UTF-8'
    )
      config.data = qs.stringify(config.data)
    if (debounce.some((item) => config.url.includes(item))) {
      //这里写加载动画
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * @description axios响应拦截器
 */
instance.interceptors.response.use(
  (response) => {
    if (loadingInstance) loadingInstance.close()
    const { data, config } = response
    const { code, msg } = data
    // 操作正常Code数组
    const codeVerificationArray = isArray(successCode)
      ? [...successCode]
      : [...[successCode]]
    // 是否操作正常
    if (codeVerificationArray.includes(code) || config.url.includes('Export')) {
      return data
    } else {
      handleCode(code, msg)
      return Promise.reject(
        'vue-admin-beautiful请求异常拦截:' +
          JSON.stringify({ url: config.url, code, msg }) || 'Error'
      )
    }
  },
  (error) => {
    if (loadingInstance) loadingInstance.close()
    const { response, message: msg } = error
    if (error.response && error.response.data) {
      const { status, data } = response
      handleCode(status, data.msg || msg)
      return Promise.reject(error)
    } else {
      let { message: msg } = error
      if (!msg) msg = '后端接口未知异常'
      else if (msg === 'Network Error') {
        msg = '网络异常'
      } else if (msg.includes('timeout')) {
        msg = '后端接口请求超时'
      } else if (msg.includes('Request failed with status code')) {
        const code = msg.substr(msg.length - 3)
        msg = '后端接口' + code + '异常'
      }
      debounceMsg(msg || `后端接口未知异常`)
      return Promise.reject(error)
    }
  }
)

export default instance
